import { Component } from '@angular/core';
import { FieldWrapper } from "@ngx-formly/core";

@Component({
  selector: 'app-generic-header-wrapper',
  templateUrl: './generic-header-wrapper.component.html',
  styleUrls: ['./generic-header-wrapper.component.scss']
})
export class GenericHeaderWrapperComponent extends FieldWrapper {


  hasErrors(): boolean {
    // if this form control has sub-fields, get their keys, and then verify if any are invalid and touched by the user
    if ( this.field.fieldGroup ) {
      const keys = this.field.fieldGroup.map(field => field.key as string);
      return keys.some(key => {
        const control = (this.form.controls as any)[key];
        return control?.touched && control?.invalid;
      });
    }

    return false;
  }
}
